import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';

import * as R from 'ramda';
import { PlanRow, RowEdit } from '@blisspointmedia/bpm-types/dist/LinearBuying';
import { Button } from '@Components/Button';
import { Dropdown } from '@Components/Dropdown';
import { Appearance, Design, Placement, Size } from '@Components/designConstants';
import { ORDERED_DEMO_GROUPINGS } from '../linear-buying-constants';
import { FormattedRow } from '../linear-buying-utils';

const MEASUREMENTS = ['Live+ Same Day AA', 'Live+ 3 Days AA', 'Live+ 7 Days AA'];

interface AddOrderedImpressionsModalProps {
  row: FormattedRow;
  editRow: (row: PlanRow, edits: RowEdit, key: string, isNewRow: boolean) => void;
  onClose: () => void;
}

export const AddOrderedImpressionsModal = ({
  row,
  editRow,
  onClose
}: AddOrderedImpressionsModalProps) => {
  const { key, isNewRow } = row;
  const [selectedDemo, setSelectedDemo] = useState<string>('');
  const [selectedMeasurement, setSelectedMeasurement] = useState<string>('');
  const [orderedImpressions, setOrderedImpressions] = useState<number>(0);

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add/Update ordered impressions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Input Ordered Impressions</Form.Label>
          <Form.Control
            type='number'
            value={orderedImpressions}
            onChange={e => setOrderedImpressions(parseInt(e.target.value, 10) || 0)}
          />
        </Form.Group>
        <Form.Group className='demo-picker'>
          <Form.Label>Select Demo</Form.Label>
          {R.keys(ORDERED_DEMO_GROUPINGS).map(group => {
            const groupDemos = ORDERED_DEMO_GROUPINGS[group];
            return (
              <div className='demo-group' key={group}>
                <strong>{group}:</strong>
                <div className='demo-buttons'>
                  {R.keys(groupDemos).map(prettyDemo => {
                    const demoValue = groupDemos[prettyDemo];
                    return (
                      <Button
                        className='demo-button'
                        key={prettyDemo}
                        appearance={
                          selectedDemo === demoValue ? Appearance.FILLED : Appearance.OUTLINED
                        }
                        onClick={() => setSelectedDemo(demoValue)}
                      >
                        {prettyDemo}
                      </Button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Form.Group>
        <Form.Group className='measurement-picker'>
          <Form.Label>Select Measurement</Form.Label>
          <Dropdown
            overlayPlacement={Placement.RIGHT}
            size={Size.LG}
            className='measurement-dropdown'
            label='Measurement'
            value={selectedMeasurement}
            options={MEASUREMENTS}
            onChange={setSelectedMeasurement}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            editRow(
              row,
              {
                orderedImpressionsDemo: selectedDemo,
                orderedImpressionsMeasurement: selectedMeasurement,
                orderedImpressions
              },
              key,
              Boolean(isNewRow)
            );
            onClose();
          }}
        >
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
